import userClient from '../config/api/userClient';
var alertUrl = "alertSettings/list";
var alertTemplateUrl = "alertSettings/listStandard";
var alertTestRuleUrl = "alertSettings/testRule";
var alertActionUrl = "alertSettings";
export var getAlert = function () {
    return userClient.get(alertUrl + "?alertType=CUSTOM");
};
export var getAlertTemplates = function () {
    return userClient.get(alertTemplateUrl);
};
export var validateRule = function (body) {
    return userClient.post("" + alertTestRuleUrl, body);
};
export var testAlert = function (body) {
    return userClient.post(alertActionUrl + "/test", body);
};
export var addAlert = function (body) {
    return userClient.post("" + alertActionUrl, body);
};
export var editAlert = function (id, body) {
    return userClient.put(alertActionUrl + "/" + id, body);
};
export var getAlertById = function (id) {
    return userClient.get(alertActionUrl + "/" + id);
};
export var deleteAlert = function (id) {
    return userClient.delete(alertActionUrl + "/" + id);
};
